import Cookie from 'js-cookie'

const removeCookie = (cookieName, domain) => {
    console.log(`Removing cookie: ${cookieName} for domain: ${domain}`)
    Cookie.remove(cookieName, {
        path: '/',
        domain: domain,
    })
}

export default removeCookie
